import { ChevronLeft, ChevronRight, Mail, MessageCircle as MessageCircleIcon } from 'lucide-react';
import { Link } from 'react-router';
import { PacienteBottomNav } from '@/app/components/paciente/PacienteBottomNav';

const faqs = [
  { question: '¿Cómo uso la cámara durante las sesiones?', category: 'Sesiones' },
  { question: '¿Qué hago si me duele al hacer un ejercicio?', category: 'Ejercicios' },
  { question: '¿Puedo cambiar el horario de mis sesiones?', category: 'Agenda' },
  { question: '¿Cómo sé si estoy haciendo bien los ejercicios?', category: 'Sesiones' },
  { question: '¿Qué significa el porcentaje de adherencia?', category: 'Progreso' },
  { question: '¿Puedo hacer sesiones extra si me siento bien?', category: 'Ejercicios' },
];

export function AyudaPaciente() {
  return (
    <div className="min-h-screen bg-background transition-colors duration-200">
      <div className="w-full max-w-[480px] mx-auto p-6 pb-24 space-y-6">
        <div className="flex items-center gap-4">
          <Link to="/perfil" className="transition-all duration-200 ease-out hover:opacity-70">
            <ChevronLeft className="w-6 h-6" strokeWidth={1.5} />
          </Link>
          <h1 className="text-2xl">Ayuda y soporte</h1>
        </div>

        <div className="bg-card rounded-3xl p-6 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)]">
          <h2 className="text-lg font-semibold mb-4">¿Necesitás ayuda?</h2>
          <p className="text-sm text-muted-foreground mb-4">
            Podés contactarnos por cualquiera de estos medios
          </p>
          <div className="grid grid-cols-2 gap-3">
            <button className="p-4 bg-primary/10 rounded-xl flex flex-col items-center gap-2 transition-all duration-200 ease-out hover:bg-primary/20">
              <Mail className="w-6 h-6 text-primary" strokeWidth={1.5} />
              <span className="text-sm font-medium">Email</span>
            </button>
            <button className="p-4 bg-primary/10 rounded-xl flex flex-col items-center gap-2 transition-all duration-200 ease-out hover:bg-primary/20">
              <MessageCircleIcon className="w-6 h-6 text-primary" strokeWidth={1.5} />
              <span className="text-sm font-medium">Chat</span>
            </button>
          </div>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-4">Preguntas frecuentes</h2>
          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <button
                key={idx}
                className="w-full bg-card rounded-2xl p-4 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)] flex items-center justify-between transition-all duration-200 ease-out hover:bg-muted/30"
              >
                <div className="text-left flex-1">
                  <p className="font-medium mb-1">{faq.question}</p>
                  <p className="text-xs text-primary">{faq.category}</p>
                </div>
                <ChevronRight className="w-5 h-5 text-muted-foreground flex-shrink-0" strokeWidth={1.5} />
              </button>
            ))}
          </div>
        </div>

        <div className="bg-card rounded-3xl p-6 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)]">
          <h2 className="text-lg font-semibold mb-2">Guía de inicio</h2>
          <p className="text-sm text-muted-foreground mb-4">
            Aprendé a usar Gonix con nuestra guía paso a paso
          </p>
          <button className="w-full bg-primary text-primary-foreground py-3 rounded-full font-semibold transition-all duration-200 ease-out hover:scale-[1.02]">
            Ver guía
          </button>
        </div>

        <p className="text-xs text-center text-muted-foreground">
          Gonix v1.0.0
        </p>
      </div>

      <PacienteBottomNav />
    </div>
  );
}
